import { render } from "./PollStart.vue?vue&type=template&id=bb0b7d08"
import script from "./PollStart.vue?vue&type=script&lang=js"
export * from "./PollStart.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__